module.exports = __webpack_public_path__ + "static/to-do-list2-35d2fc4a5f8ddda5dcaab5d11f62d25e.jpg";